import { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { GALLERY } from "@/constants/hotelData";
import Reveal from "@/components/Reveal";

export default function Gallery() {
  const [open, setOpen] = useState(null);

  return (
    <section id="gallery" className="bg-[#0f241b] py-24 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="mb-4 text-[10px] font-medium uppercase tracking-[0.34em] text-gold sm:text-xs">Gallery</p>
          <h2 className="font-serif text-3xl tracking-tight text-cream sm:text-4xl lg:text-[2.75rem]">
            A walk through the hotel
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 gap-4 md:grid-cols-4">
          {GALLERY.map((g, i) => (
            <Reveal
              key={i}
              delay={0.05 * i}
              className={i === 0 ? "col-span-2 row-span-2" : ""}
            >
              <button
                data-testid={`gallery-item-${i}`}
                onClick={() => setOpen(g)}
                className="group relative block h-full w-full overflow-hidden rounded-xl border border-gold/10"
              >
                <img
                  src={g.src}
                  alt={g.alt}
                  className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${
                    i === 0 ? "aspect-square md:h-full" : "aspect-[4/3]"
                  }`}
                />
                <div className="absolute inset-0 bg-ink/0 transition-colors duration-300 group-hover:bg-ink/25" />
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent className="max-w-4xl border-gold/20 bg-ink p-2 sm:p-3" data-testid="gallery-lightbox">
          {open && (
            <img src={open.src} alt={open.alt} className="max-h-[80vh] w-full rounded-lg object-contain" />
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
}
